import * as React from 'react'
import { CookieSensitiveContentWrapper } from '../../cms/blocks/cookiebar.mod'

export const ParadoxLoader = () => (
  // <CookieSensitiveContentWrapper groupId={2}>
    <ParadoxLoaderAux />
  // </CookieSensitiveContentWrapper>
)

const ParadoxLoaderAux = () => {
  React.useEffect(loadParadox, [])
  return <></>
}

const loadParadox = () => {
  const allowedHosts = ['www.refresco.com'] // production hosts where the key is allowlisted
  if (!allowedHosts.includes(window.location.hostname)) return
  
  window.oliviaChatData = window.oliviaChatData || []
  window.oliviaChatBaseUrl = 'https://olivia.paradox.ai'
  window.oliviaChatData.push(['setKey', 'divsgweofyhgtseqknds'])
  window.oliviaChatData.push(['start'])
  var apply = document.createElement('script')
  apply.type = 'text/javascript'
  apply.async = true
  apply.src = 'https://dokumfe7mps0i.cloudfront.net/static/site/js/widget-client.js'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(apply, s)
}
